import request from '../request'


export function getQuestion() {
    return request({
        url: `/study/question`,
        method: 'get',
    })
}